import ContactInfoArea from './ContactInfoArea';

export default ContactInfoArea;
